














































































































































import {Component, Prop} from 'vue-property-decorator';
import Form, { Send } from '@/components/form-base';
import { mixins } from 'vue-class-component';
import { DialogForm, FormOverlay } from '@/components/bwaff';
import HeaderButtons from '@/components/ui/ui-modal/modal/header-buttons.vue'
import Template from '@/views/reports/forms/traffic_sources/template.vue';
import PeriodPicker from '@/views/reports/pickers/period-picker.vue';
import ReportMetricsMixin from '@/views/reports/mixins/report-metrics-mixin';
import moment from 'moment';
import SharedReports from '@/services/rest/bemob/shared-reports';
import ErrorAggregator from '@/components/errors/error-aggregator.vue';
import ReportFiltersCommon from '@/views/reports/report-filters-common';
import PickersBaseMixin from '@/views/reports/pickers/base';
import UrlMixin from '@/components/query/url-mixin';
import { TagsLogicalRelationEnum } from '@/services/models/Enums';
import _ from 'lodash';
import {AppRouter} from '@/routes';
import MetricsMixin from '@/views/reports/pickers/base/metrics-mixin';
import PickerMixin from '@/views/reports/mixins/picker-mixin';
import ColumnsSettingsDialogMixin from '@/views/reports/pickers/cores/columns-settings-dialog/columns-settings-dialog-mixin';

const md5 = require('md5');

interface ShareReportHavingFilter {
  table: string;
  option: string;
  value: number;
}

const filledFilterValue = (value: unknown) => {
  if (value == null || value === '') return false
  return !Array.isArray(value) || value.length > 0
}

const reportFilterConditions = (source: {
  search?: unknown;
  searchBy?: unknown;
  textLogicalRelation?: unknown;
  tags?: unknown;
  tagsLogicalRelation?: unknown;
  marks?: unknown;
  marksFilterMode?: unknown;
  filterHaving?: unknown;
  filterHavingOptions?: unknown;
  filterHavingValues?: unknown;
  havingFilters?: ShareReportHavingFilter[];
} | null | undefined) => {
  if (!source) return {}

  const searchBy = typeof source.searchBy === 'string' ? source.searchBy : ''
  const conditions: Pick<
    FormFields,
    | 'search'
    | 'searchBy'
    | 'textLogicalRelation'
    | 'tags'
    | 'tagsLogicalRelation'
    | 'marks'
    | 'marksFilterMode'
    | 'havingFilters'
  > = {}

  if ((searchBy === 'text' || (!searchBy && filledFilterValue(source.search))) && filledFilterValue(source.search)) {
    conditions.searchBy = 'text'
    conditions.search = source.search as string | string[]
    if (filledFilterValue(source.textLogicalRelation)) {
      conditions.textLogicalRelation = String(source.textLogicalRelation)
    }
  }

  if (searchBy === 'tags' && filledFilterValue(source.tags)) {
    conditions.searchBy = 'tags'
    conditions.tags = source.tags as string[]
    if (filledFilterValue(source.tagsLogicalRelation)) {
      conditions.tagsLogicalRelation = String(source.tagsLogicalRelation)
    }
  }

  if ((searchBy === 'marks' || searchBy.startsWith('marks-')) && filledFilterValue(source.marks)) {
    conditions.searchBy = 'marks'
    conditions.marks = source.marks as Array<string | number>
    conditions.marksFilterMode = String(
      source.marksFilterMode || (searchBy.includes('exclude') ? 'exclude' : 'include'),
    )
  }

  if (Array.isArray(source.havingFilters) && source.havingFilters.length) {
    conditions.havingFilters = source.havingFilters
  } else if (Array.isArray(source.filterHaving) && source.filterHaving.length) {
    const options = Array.isArray(source.filterHavingOptions) ? source.filterHavingOptions : []
    const values = Array.isArray(source.filterHavingValues) ? source.filterHavingValues : []
    const havingFilters = source.filterHaving
      .map((table, index) => ({
        table: String(table),
        option: String(options[index] ?? ''),
        value: Number(values[index]),
      }))
      .filter((item) => (
        item.table
        && ['greater', 'lower', 'equals'].includes(item.option)
        && Number.isFinite(item.value)
      ))
    if (havingFilters.length) conditions.havingFilters = havingFilters
  }

  return conditions
}

interface FormFields {
  reportPeriodEnd: string;
  reportPeriodStart: string;
  timezone: string;
  name: string;
  showDate: boolean;
  availableUntil?: string;
  disableAvailableUntil?: boolean;
  columnsType?: string;
  status: string;
  columnsStatus: string;
  date: string;
  groupBy: string | string[];
  search?: string | string[];
  searchBy?: string;
  marks?: Array<string | number>;
  marksFilterMode?: string;
  tags?: string[];
  tagsLogicalRelation?: TagsLogicalRelationEnum | string;
  textLogicalRelation?: TagsLogicalRelationEnum | string;
  havingFilters?: ShareReportHavingFilter[];
  updated?: string;
  created?: string;
  updatedBy?: string;
  filters?: object;
  workspaceIds: [];
  orderBy?: string;
  orderDir?: string;
  currency?: string;
}

@Component({
  components: {
    Template,
    FormOverlay,
    DialogForm,
    HeaderButtons,
    PeriodPicker,
    ErrorAggregator,
  }
})


export default class ShareReportDialog extends mixins(
    Form,
    PickersBaseMixin,
    ReportMetricsMixin,
    ReportFiltersCommon,
    mixins(ColumnsSettingsDialogMixin, UrlMixin, MetricsMixin, PickerMixin)
  ){

  sharedReportsApi: SharedReports = new SharedReports();
  active: boolean = false;
  searchColumn: string = '';
  columns = {};
  selectAll: boolean = false;
  dateFormat: string = 'YYYY-MM-DD hh:mm:ss';
  disabledColumns={}

  errors: any[] = [];
  errorsControlActive: boolean = false;

  form: FormFields = {
    reportPeriodStart: null,
    reportPeriodEnd: null,
    timezone: '',
    name: '',
    showDate: true,
    availableUntil: null,
    disableAvailableUntil: false,
    date: 'today',
    status: null,
    columnsStatus: null,
    groupBy: [],
    filters: {},
    workspaceIds: [],
    currency: null,
  }

  @Prop({ default: {} })
  data: {
    formData:{
      id:string,
      name:string,
      availableUntil:string,
      status:string,
      timezone:string,
      queryConditions: {
        columns:string,
        columnsType:string,
        status: string,
        groupBy:string | string[],
        date:string,
        from:string,
        to:string,
        filters:object,
        workspaceIds:string[],
        orderBy:string,
        orderDir:string,
        currency:string,
        search?: string | string[],
        searchBy?: string,
        textLogicalRelation?: string,
        tags?: string[],
        tagsLogicalRelation?: string,
        marks?: Array<string | number>,
        marksFilterMode?: string,
        havingFilters?: ShareReportHavingFilter[],
      },
      created:string,
      updated:string,
      updatedBy:string,
      showDate:boolean
    },
    action: 'edit'|'duplicate'
  };

  mounted() {
    this.$on('error', (e: any) => {
      this.errors = this.translateErrors(this.parseErrors(e.data.errors), e.data.message);
      this.errorsControlActive = true;
    });

    if (!_.isEmpty(this.data.formData)) {
      const { name, queryConditions, id, availableUntil, status, created, updated, updatedBy, showDate, timezone } = this.data.formData
      const { columns, columnsType, date, status: columnsStatus, groupBy, from, to, filters, workspaceIds, orderBy, orderDir, currency} = queryConditions

      this.form = {
        ...this.defaultForm(),
        name: this.data.action==='duplicate' ? name + ' (' + this.t('____x.copy') + ')' : name,
        availableUntil: 
          availableUntil 
            ? this.formatDateLocal(availableUntil) 
            : this.defaultForm().availableUntil,
        disableAvailableUntil: !availableUntil,
        columnsType,
        status,
        columnsStatus,
        groupBy,
        ...(date && date !=='customDateTime' ? {
          reportPeriodStart:  this.getRangeValueColection({timezone})[date].from,
          reportPeriodEnd:  this.getRangeValueColection({timezone})[date].to,
        }:{
          reportPeriodStart: from,
          reportPeriodEnd: to,
        }),
        timezone,
        created,
        date: date || 'customDateTime',
        updated,
        updatedBy,
        filters,
        showDate,
        workspaceIds,
        orderBy,
        orderDir,
        currency: currency || this.$store.state.user.currencyId,
        ...reportFilterConditions(queryConditions),
      } as FormFields

      this.setSelectedColumns(columns)
    } else {
      const initialFilters = this.getFilters();
      const { status: columnsStatus, orderBy, orderDir } = initialFilters

      const { user } = this.$store.state;
      const savedColumns = this.$store.getters.savedColumnsInCurentPreset

      const reportParams = this.$store.getters.reportParams;
      const { from, to, timezone, currency,date } = reportParams || {};
      const { selectedWorkspaces } = user

      const selectedColumns = savedColumns[this.storeColumns].columns

      this.form = {
        ...this.defaultForm(),
        columnsType: this.storeColumns,
        reportPeriodStart: from,
        reportPeriodEnd: to,
        timezone,
        status: 'active',
        columnsStatus,
        date,
        groupBy: this.groupBy,
        orderBy,
        orderDir,
        currency:currency || this.$store.state.user.currencyId,
        workspaceIds: selectedWorkspaces,
        filters: this.filters,
        ...reportFilterConditions(reportParams),
      } as FormFields

      this.setSelectedColumns(selectedColumns)
    }

    this.selectAll = this.selectedColumns.length === Object.keys(this.columns).length
    this.searchColumn = '';
    this.active = true;

    this.$nextTick(() => {
      this.oldHash = this.getCurrentHash();
    });
  } 

  get reportTitle() {
    switch(this.data?.action) {
      case 'duplicate':
        return this.t('Duplicate Shared Report')
      case 'edit':
        return this.t('Edit Shared Report')
      default:
        return this.t('Create Shared Report')
    }
  }
 
  get dateValues() {
    return [
      {value: 'today',          text: this.t('Today')},
      {value: 'yesterday',      text: this.t('Yesterday')},
      {value: 'last24hours',    text: this.t('Last 24 Hours')},
      {value: 'last48hours',    text: this.t('Last 48 Hours')},
      {value: 'last3days',      text: this.t('Last 3 days')},
      {value: 'last7days',      text: this.t('Last 7 days')},
      {value: 'last30days',     text: this.t('Last 30 days')},
      {value: 'thisMonth',      text: this.t('This Month')},
      {value: 'lastMonth',      text: this.t('Last Month')},
      {
        value: 'maxAvailable',
        text: this.t('Max. available'),
      },
      {value: 'customDateTime', text: this.t('Date Range')},
    ]
  }

  get submitButtonText() {
    switch(this.data?.action) {
      case 'duplicate':
        return this.t('Create Link')
      case 'edit':
        return this.t('Save')
      default:
        return this.t('Create Link')
    }
  }

  oldHash: string = '';

  handleUpdateAvailableUntil(date) {
    this.form.availableUntil = date.format('YYYY-MM-DD HH:mm:ss')
  }

  maxDate() {
    return moment().add(59, 'days').valueOf()
  }

  getCurrentHash() {
    return md5(JSON.stringify({ ...this.form, ...this.columns }));
  }

  checkClose() {
    if (this.oldHash !== this.getCurrentHash()) {
      this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: { onConfirm: () => this.close() }})
    } else {
      this.close();
    }
  }

  handleUpdatePeriod({ from, to, timezone }: TimeRange) {
    this.form.reportPeriodStart = from;
    this.form.reportPeriodEnd = to;
    this.form.timezone = timezone;
  }

  defaultForm() {
    return {
      name: this.$store.getters.selectedItem.name || '',
      availableUntil: moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      showDate: true,
    };
  }

  get columnsList() {
    const { columnsType } = this.form;
    return this.getMetricsList(this.$route.name, columnsType).map((item)=>{
      if(item.disabled){
        this.disabledColumns[item.value]=true;
        // always enable disabled columns
        this.columns[item.value] = true;
      }
      return {
        ...item,
        planLimits:this.getPlanLimits(item)
      }
    })
  }

  get selectedColumns() {
    return Object.entries(this.columns).reduce((acc, [key, value]) => {
      if (value) {
        acc.push(key)
      }
      return acc
    }, [])
  }

  toggleSelectAll(val) {
    this.columnsList.forEach(({ value }) => {
      if(this.disabledColumns[value]) return;
      this.columns[value] = val;
    })
  }

  handleToggle(key, value) {
    this.columns[key] = value
    this.selectAll = this.selectedColumns.length === Object.keys(this.columns).length
  }

  get filteredColumns() {
    return this.columnsList.filter(({ text }) => text.toLowerCase().includes(this.searchColumn.toLowerCase())
    )
  }

  setSelectedColumns(selectedColumns) {
    this.columns = this.columnsList.reduce((acc, { value }) => {
      acc[value] = selectedColumns.includes(value)
      return acc
    }, {})
  }

  formatDateLocal(date) {
    return moment(moment.utc(date).toDate()).local().format('YYYY-MM-DD HH:mm:ss')
  }

  dateToUtc(date) {
    return moment(date).utc().format('YYYY-MM-DD HH:mm:ss')
  }

  get isTreeView() {
    return this.$store.getters.reportParams.view === 'tree' && this.$store.getters.tableQueryForCurrentTab.treeLevels?.some((e: string) => e);
  }

  get updateData() {
    const { updated, created } = this.form
    return { updated, created }
  }

  get groupBy() {
    const { reportParams } = this.$store.getters;
    const arrayGroup = Array.isArray(reportParams.groupBy) ? reportParams.groupBy : [reportParams.groupBy]
    return this.isTreeView ? [...arrayGroup, ...(this.$store.getters.tableQueryForCurrentTab.treeLevels || [])] : arrayGroup
  }

  get filters() {
    const { selectedItems } = this.$store.state.table;
    const initialFilters = this.getFilters();
    const res = []

    const mapKeyFilter = {
      filterOptions: 'option',
      filterTables: 'table',
      filterValues: 'value',
    }

    const arrayFilters = Object.entries(_.pick(initialFilters, ['filterOptions', 'filterTables', 'filterValues']))
    const selectedIds = selectedItems.map(({ DT_RowId }) => DT_RowId)

    if (arrayFilters.length) {
      const filters = arrayFilters.reduce((acc, [key, value]) => {
        if (key === 'filterTables') {
          acc[mapKeyFilter[key]] = value[0]
        } else if (key === 'filterValues') {
          acc[mapKeyFilter[key]] = value[0].split('^')
        } else {
          acc[mapKeyFilter[key]] = value
        }
        return acc
      }, {})
      res.push(filters)
    }

    if (selectedIds.length) {
      res.push({
        value: selectedIds,
        table: this.groupBy[0],
        option: 'equals'
      })
    }

    return res
  }

  close() {
    this.$emit('close');
  }

  @Send(true)
  submit() {
    const {
      name,
      availableUntil,
      disableAvailableUntil,
      reportPeriodStart,
      reportPeriodEnd,
      timezone,
      columnsType,
      status,
      columnsStatus,
      groupBy,
      filters,
      showDate,
      workspaceIds,
      orderBy,
      orderDir,
      currency,
      date
    } = this.form
    const { id: userId, currencyId } = this.$store.state.user;

    const data = {
      userId,
      name,
      availableUntil: disableAvailableUntil ? null : this.dateToUtc(availableUntil),
      status,
      showDate,
      timezone,
      queryConditions: {
        columnsType,
        status: columnsStatus,
        from: reportPeriodStart,
        to: reportPeriodEnd,
        columns: this.selectedColumns,
        currency:currency || currencyId,
        groupBy,
        filters,
        date,
        workspaceIds,
        ...reportFilterConditions(this.form),
        ...(this.selectedColumns.includes(orderBy) && {
          orderBy,
          orderDir,
        })
      },
    }

    if (this.data.action==='edit') {
      return this.sharedReportsApi.put(this.data.formData.id, data).then(() => {
        this.bus.emit('load-shared-reports');
        this.close()
        this.bus.emit('toast-success', this.t('Shared report successfully updated'));
      })
    } else {
      return this.sharedReportsApi.post(data).then(({ id, name}) => {
        this.close()

        if(this.data.action==='duplicate'){
          this.bus.emit('load-shared-reports');
        }
        this.bus.emit('open-dialog', { name: 'CreateLinkDialog', data: { id, name } });
        this.bus.emit('toast-success', this.t('Shared report successfully created'));

        this.$mixpanel?.track('shared_report_create', {
          'page_title': (this.$router as AppRouter).getPageTitle()
        });
      })
    }
  }

}
